// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { CustomAppState } from "@pace/App/Store/Reducers";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export const XngPopulateCart: typeof PopulateCart = props => {
    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
        xCheckout: {
            shipping: { timeslot, shipPartial },
        },
        context: {
            session: { fulfillmentMethod },
        },
    } = props.getState() as CustomAppState;


    props.cart = {
        ...props.cart,
        properties: {
            ...props.cart.properties,
            shipPartial: shipPartial || "true",
            deliverAnytime: timeslot === "" ? "true" : "false",
        },
        requestedDeliveryDate: convertDateToApiFormat(requestedDeliveryDate as any),
        requestedPickupDate: convertDateToApiFormat(requestedPickupDate as any),
        fulfillmentMethod,
    };
};

// XNG-Changes: PAC-548
export const XngLoadShipTos: typeof PopulateCart = props => {
    const { dispatch, getState } = props;
    const state = getState() as CustomAppState;
    const {
        pages: {
            checkoutShipping: { shippingAddressFormState },
        },
    } = state;
    if (!shippingAddressFormState) {
        return;
    }
    const { address: localModifiedShipTo } = shippingAddressFormState;
    if (localModifiedShipTo.isNew) {
        dispatch(loadShipTos(state.xCheckout.shipping.shipTosParams));
    }
};

addToChainAfter(chain, PopulateCart, XngPopulateCart);
addToEndOfChain(chain, XngLoadShipTos);
